import { BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import ScrollToTop from "@/components/ui/ScrollToTop";
import ScrollProgress from "@/components/ui/ScrollProgress";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingContact from "@/components/ui/FloatingContact";
import AnimatedRoutes from "@/components/layout/AnimatedRoutes";
import SmoothScroll from "@/components/ui/SmoothScroll";
import CustomCursor from "@/components/ui/CustomCursor";
import WhatsAppButton from "@/components/ui/WhatsAppButton";
import ErrorBoundary from "@/components/ui/ErrorBoundary";
import CookieConsent from "@/components/ui/CookieConsent";
import RouteSeo from "@/components/seo/RouteSeo";
import { initAnalytics } from "@/lib/analytics";
import { initMonitoring } from "@/lib/monitoring";

export function App() {
  useEffect(() => {
    initAnalytics();
    initMonitoring();
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <RouteSeo />
        <SmoothScroll />
        <CustomCursor />
        <ScrollToTop />
        <ScrollProgress />
        <Header />
        <main id="main-content" className="min-h-screen">
          <AnimatedRoutes />
        </main>
        <Footer />
        <WhatsAppButton />
        <FloatingContact />
        <CookieConsent />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
